import { ChangeRoleModalTranslations } from "./types";

export const enTranslations: ChangeRoleModalTranslations = {
    title: "Change Role",
    options: {
        Teacher: "Teacher",
        Admin: "Admin",
    },
    submit: "Submit",
};
